import { IRosreestrDataState, EResponseStatus, EErrorType } from '../../types/reducers/rosreestrData';

const ERRORS = {
  [EErrorType.ValidationError]: 'Неправильный номер',
  [EErrorType.RequiredError]: 'Укажите номер',
};

export const defaultState: IRosreestrDataState = {
  address: null,
  cardView: null,
  autofields: {},
  cadastralFieldsMeta: {
    buildingCadastralNumber: {
      errors: {
        [EErrorType.ValidationError]: {
          value: '',
          message: ERRORS[EErrorType.ValidationError],
        },
        [EErrorType.RequiredError]: {
          value: false,
          message: ERRORS[EErrorType.RequiredError],
        },
      },
      isChecking: false,
      isRequired: false,
    },
    cadastralNumber: {
      errors: {
        [EErrorType.ValidationError]: {
          value: '',
          message: ERRORS[EErrorType.ValidationError],
        },
        [EErrorType.RequiredError]: {
          value: false,
          message: ERRORS[EErrorType.RequiredError],
        },
      },
      isChecking: false,
      isRequired: true,
    },
  },
  responseStatus: EResponseStatus.Initial,
};
